// globalData.js

export default {
  socket: null,
  reconnectInterval: null,
  date: '连接中',
  tableList: null,
  // SOCKET_URL: 'ws://localhost:8015/web/v1/ws'
  SOCKET_URL: 'ws://www.idjyj.com/web/v1/ws',
  token: '02db90c36b86b6e8c3b084d76fa8e452881f5d82',

  socketws: null,
  reconnectIntervalws: null,
  datews: '连接中',
  tableListws: null,
  // SOCKET_URL: 'ws://localhost:8015/web/v1/ws'
  SOCKET_URL_WS: 'ws://www.idjyj.com/web/v1/ws-ws'
}



// WEBPACK FOOTER //
// ./src/common/globalData.js